var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showSearch,
          expression: "showSearch",
        },
      ],
      ref: "queryForm",
      staticClass: "bj-query-form bj-query-form-for-cal-height",
      attrs: {
        "label-position": _vm.labelPosition,
        "label-suffix": _vm.labelSuffix,
        model: _vm.queryParams,
        rules: _vm.rules,
        inline: _vm.inline,
        "label-width": _vm.labelWidth,
        size: _vm.size,
      },
    },
    [
      _vm.inline
        ? [
            _vm._t("baseForm"),
            _vm.showSeniorSearch ? _vm._t("seniorForm") : _vm._e(),
            "{}" !== JSON.stringify(_vm.queryParams) && !_vm.searchBtnHide
              ? _c(
                  "el-form-item",
                  { attrs: { label: "" } },
                  [
                    _vm._t("startBtnGroup"),
                    _c(
                      "el-button",
                      {
                        attrs: { type: _vm.btnSearchStyle.type, plain: "" },
                        on: { click: _vm.handleQuery },
                      },
                      [_vm._v(_vm._s(_vm.searchButtonText))]
                    ),
                    _vm.$slots.seniorForm
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "cyan", plain: "" },
                            on: { click: _vm.toggleSeniorSearch },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.showSeniorSearch
                                  ? _vm.$t("closeAdvancedQueryText")
                                  : _vm.$t("advancedQueryText")
                              )
                            ),
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        attrs: { type: _vm.btnResetStyle.type, plain: "" },
                        on: { click: _vm.resetQuery },
                      },
                      [_vm._v(_vm._s(_vm.$t("resetText")))]
                    ),
                    _vm._t("endBtnGroup"),
                  ],
                  2
                )
              : _vm._e(),
          ]
        : [
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _vm._t("baseForm"),
                _vm.showSeniorSearch ? _vm._t("seniorForm") : _vm._e(),
                _vm._t("beforeSearchBtn"),
                "{}" !== JSON.stringify(_vm.queryParams) && !_vm.searchBtnHide
                  ? _c(
                      "el-col",
                      {
                        staticStyle: {
                          "margin-bottom": "18px",
                          display: "flex",
                          "justify-content": "flex-end",
                        },
                        attrs: { span: _vm.remainderSpan },
                      },
                      [
                        _vm._t("startBtnGroup"),
                        _vm.$slots.seniorForm
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "cyan", plain: "" },
                                on: { click: _vm.toggleSeniorSearch },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.showSeniorSearch
                                      ? _vm.$t("closeAdvancedQueryText")
                                      : _vm.$t("advancedQueryText")
                                  )
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "el-button",
                          {
                            attrs: { type: _vm.btnSearchStyle.type, plain: "" },
                            on: { click: _vm.handleQuery },
                          },
                          [_vm._v(_vm._s(_vm.searchButtonText))]
                        ),
                        !_vm.resetBtnHide
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  type: _vm.btnResetStyle.type,
                                  plain: "",
                                },
                                on: { click: _vm.resetQuery },
                              },
                              [_vm._v(_vm._s(_vm.$t("resetText")))]
                            )
                          : _vm._e(),
                        _vm._t("endBtnGroup"),
                      ],
                      2
                    )
                  : _vm._e(),
              ],
              2
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }